/**
 * 用户股吧callback的h参数
 */
import md5 from "./guba_md5";
import cookie from "../cookie";

export function getH(){
  var ct = cookie.get("ct")
  var ut = cookie.get("ut")
  //拼接字符
  var str = "ctoken="+ct+"utoken="+ut+"_519d77b29be442f8"
  //md5加密,加密后的结果即为h参数
  return md5.hex_md5(str)
}
